var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ disabled: !!_vm.disabled },on:{"click":_vm.onclick}},[_c('Icon',_vm._b({attrs:{"icon":_vm.icon}},'Icon',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }